const {h, render, Component} = require('preact');
const queryString = require('qs');
const {route} = require('preact-router');

const SupportAPIHelper = require('../../../../../support/frontend/helpers/API')
const Web2018Helper = require('../../../helper')
const FAQSearch = require('./faq_search')
const SearchResults = require('./search_results')
const Spinner = require('../../views/common/spinner')
const ErrorView = require('../main/error')
const SessionHelper = require('../../../helper')

class FAQSearchBar extends Component {
  constructor(props) {
    super(props);
    this.handleNeedHelpFromSearchResults = this.handleNeedHelpFromSearchResults.bind(this);
  }

  getSearchResults(){
    let searchText = this.props.searchText
    let searchUrl = `${Groupon.Utils.getConfigFromDom().FAQBASEURL}`
    let inbentaSessionToken = sessionStorage.getItem('inbentaSessionKey')

    if (inbentaSessionToken === null || inbentaSessionToken === undefined) {
        SessionHelper.createSession()
    }

    let queryParams = {
      inbentaSessionToken: inbentaSessionToken,
      searchText: searchText
    }

    let qs = queryString.stringify(queryParams)
    searchUrl = `${searchUrl}/search?${qs}`;

    let errorCb = () => {
      this.setState({searchResults: null, 'isFailure': true});
    }

    let successCb = (response) => {
      if(response)
      {
        this.setState({searchResults: response, searchText: searchText});
      }
    }
    SupportAPIHelper.get(searchUrl, null, successCb, errorCb, false);
  }

  componentWillMount(){
    this.getSearchResults();
  }

  componentDidUpdate(prevProps){
    if (this.props.searchText !== prevProps.searchText) {
      this.getSearchResults();
    }
  }

  handleNeedHelpFromSearchResults(selectedInbentaResult){
    selectedInbentaResult = _.omit(selectedInbentaResult, 'answer', 'bloodhoundTracking')
    let configFromDom = Groupon.Utils.getConfigFromDom()
    let qs = Web2018Helper.getQueryStringForFAQToContactChannels(selectedInbentaResult)
    if (configFromDom && configFromDom.user){
        route(`/customer_support/web/contact_channels?${ qs }`);
    }
    else{
      if(Web2018Helper.canSkipLogIn(configFromDom, selectedInbentaResult)){
        route(`/customer_support/web/contact_channels?${ qs }`);
      }
      else if(configFromDom.guestCheckoutEnabledInWeb && this.props.guestOrder) { // guest checkout help
        route(`/customer_support/web/contact_channels?${ qs }`);
      }
      else
      {
        let queryString = Web2018Helper.getQueryStringForFAQToContactChannels(selectedInbentaResult, { encode: false })
        let referenceUrl = `${configFromDom.SUPPORTBASEURL}?${ queryString }`
        window.location.href = `/login?return_to=${ encodeURIComponent(referenceUrl) }`
      }
    }
  }

  getSearchResultsComponent(){
    if (this.state.isFailure) {
      return (<ErrorView/>)
    }
    else if (this.state.searchResults){
      return <SearchResults
                results={this.state.searchResults}
                searchText={this.state.searchText}
                handleNeedHelpFromSearchResults={this.handleNeedHelpFromSearchResults}
                onGuestHelp={this.props.onGuestHelp}
                showGuestHelp={this.props.showGuestHelp}
              />;
    }
    else{
      return <Spinner />;
    }
  }

  render() {
    return (
      <div class="row">
        <div style="margin-left: 14px">
          <FAQSearch
            searchText={this.props.searchText}
          />
          {this.getSearchResultsComponent()}
        </div>
      </div>
    )
  }
}

module.exports = FAQSearchBar
